import { Table } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint, useHasScroll } from 'shared/lib';
import { NumberFormatter } from 'shared/ui';
import { highrollersModalModel } from '../../model';
import BronzeCupIcon from '../assets/bronze-cup-icon.svg?react';
import GoldCupIcon from '../assets/gold-cup-icon.svg?react';
import SilverCupIcon from '../assets/silver-cup-icon.svg?react';
import cls from './highrollers-modal-table.module.scss';

const icons = [GoldCupIcon, SilverCupIcon, BronzeCupIcon];

export const HighrollersModalTable = () => {
	const { t } = useTranslation();

	const [highrollers, currency] = useUnit([
		highrollersModalModel.$highrollers,
		highrollersModalModel.$currency,
	]);

	const sm = useBreakpoint('sm', false);

	const { ref, isHas } = useHasScroll();

	const rows = highrollers.map((highroller, idx) => {
		const Icon = idx > 2 ? null : icons[idx];

		return (
			<Table.Tr key={`${idx.toString()}`}>
				<Table.Td
					data-with-icon={Icon !== null || undefined}
					className={cls.highrollersModalTableUsername}
				>
					{Icon && <Icon className={cls.highrollersModalTableIcon} />}
					{highroller.username}
				</Table.Td>
				<Table.Td>
					<NumberFormatter value={highroller.multiplier} />
					{t('multiplier')}
				</Table.Td>
				<Table.Td className={cls.highrollersModalTableWin}>
					<NumberFormatter value={highroller.profit} />
				</Table.Td>
				<Table.Td className='native'>{currency}</Table.Td>
			</Table.Tr>
		);
	});

	return (
		<div
			ref={ref}
			className={cls.highrollersModalTable}
			data-scroll={isHas || undefined}
		>
			<Table size={sm ? 'md' : 'sm'}>
				<colgroup>
					<col />
					<col />
					<col />
					<col />
				</colgroup>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>{t('highrollers-modal.username')}</Table.Th>
						<Table.Th>{t('highrollers-modal.odds')}</Table.Th>
						<Table.Th>{t('highrollers-modal.win')}</Table.Th>
						<Table.Th>{t('highrollers-modal.currency')}</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>{rows}</Table.Tbody>
			</Table>
		</div>
	);
};
